import { Instance } from "../../Base";
import Decorator from "../Decorator";

export default class MarketingConsentDecorator extends Decorator {
  private childEventListenersAdded = false;

  private countSelections = (checkboxes: any[]) =>
    checkboxes.reduce((acc, checkbox) => {
      if (checkbox.checked) {
        return acc + 1;
      }
      return acc;
    }, 0);

  private hideChildElements = (checkboxes: any) => {
    checkboxes.forEach((checkbox: any) => {
      const container = checkbox.parentElement.parentElement.parentElement;
      container.style.display = "none";
    });
  };

  // Shows/hides the nested comm-pref checkboxes to match the marketing
  // consent state. `isTrusted` distinguishes a real user click (which also
  // auto-checks the children) from programmatic/initial syncs (which must
  // preserve the children's pre-populated values, e.g. on editProfileForm).
  private sync = (
    target: HTMLInputElement,
    isTrusted: boolean,
    excludedFields?: string[]
  ) => {
    const personalizationCheckbox: any = document.getElementById("personalizationConsentRegistration");
    const communicationOptinsCheckboxes = Array.from(
      document.querySelectorAll("[id^='communicationOptins_']")
    ).filter(el => !excludedFields?.includes(el.id));

    // Include personalization checkbox in the list if it exists
    const hiddenCheckboxes = personalizationCheckbox
      ? communicationOptinsCheckboxes.concat(personalizationCheckbox)
      : communicationOptinsCheckboxes;

    hiddenCheckboxes.forEach((checkbox: any) => {
      const container = checkbox?.parentElement?.parentElement?.parentElement;
      if (!this.childEventListenersAdded) {
        checkbox.addEventListener("click", (innerElement: any) => {
          if (
            innerElement.isTrusted &&
            this.countSelections(hiddenCheckboxes) === 0
          ) {
            target.checked = false;
            this.hideChildElements(hiddenCheckboxes);
          }
        });
      }

      if (container) {
        container.style.display = !target.checked ? "none" : "block";
      }
      if (!target.checked) {
        checkbox.checked = false;
      } else {
        if (isTrusted && checkbox !== personalizationCheckbox) {
          checkbox.checked = true;
        }
      }
    });

    this.childEventListenersAdded = true;
  };

  constructor(component: Instance, excludedFields?: string[]) {
    super(component);

    const marketingConsentRegistration =
      component.element.querySelector("input");

    if (marketingConsentRegistration) {
      marketingConsentRegistration.addEventListener("click", (event: any) => {
        this.sync(event.target, event.isTrusted, excludedFields);
      });

      // editProfileForm pre-populates checkbox values without firing click
      // events, so a consumer whose marketing consent is already granted
      // would never see the nested comm-pref checkboxes (they start hidden
      // via HideCheckboxDecorator). Sync once after the rest of the form has
      // rendered — deferred because the child checkboxes are built after
      // this field.
      setTimeout(() => {
        if (marketingConsentRegistration.checked && !this.childEventListenersAdded) {
          this.sync(marketingConsentRegistration, false, excludedFields);
        }
      }, 0);
    }
  }
}
